import React, { useState } from 'react';
import { useLanguage } from '../../utils/languageContext.js';
import Dropdown from '../comman/dropdown.js';
import DropdownMenuItem from '../comman/dropdownMenuItem.js';

const LanguageSwitcher = () => {
    const { language, changeLanguage } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const [animationClass, setAnimationClass] = useState('');

    const languageOptions = [
        { code: 'am', label: 'Հայերեն', flag: '🇦🇲' },
        { code: 'ru', label: 'Русский', flag: '🇷🇺' },
        { code: 'en', label: 'English', flag: '🇬🇧' }
    ];

    const currentLanguage = languageOptions.find(option => option.code === language);

    const handleLanguageChange = (code) => {
        if (code !== language) {
            setAnimationClass('animate-pulse');
            setTimeout(() => setAnimationClass(''), 500);
            changeLanguage(code);
        }
        setIsOpen(false);
    };

    return (
        <Dropdown
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            position="bottom-right"
            className="w-52"
            trigger={
                <button
                    className={`flex items-center justify-between space-x-2 px-3.5 py-2 rounded-full bg-white dark:bg-[#161b22] border border-gray-200 dark:border-[#30363d] shadow-sm hover:shadow-md hover:border-gray-300 dark:hover:border-[#484f58] transition-all duration-200 text-sm font-medium min-w-[90px] ${isOpen ? 'ring-2 ring-gray-200 dark:ring-[#30363d]' : ''} ${animationClass}`}
                    aria-label="Select language"
                    aria-expanded={isOpen}
                    aria-haspopup="true"
                >
                    <div className="flex items-center">
                        <span className="text-base mr-2">{currentLanguage.flag}</span>
                        <span className="text-gray-800 dark:text-[#c9d1d9] font-medium">{currentLanguage.code.toUpperCase()}</span>
                    </div>
                    <svg 
                        className={`w-4 h-4 text-gray-500 dark:text-[#8b949e] transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24" 
                        xmlns="http://www.w3.org/2000/svg"
                        strokeWidth={2.5}
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </button>
            }
        >
            {languageOptions.map((option) => (
                <div key={option.code} className="relative">
                    {language === option.code && (
                        <span className="absolute left-0 top-0 bottom-0 w-1 bg-green-500 dark:bg-green-500 rounded-r"></span>
                    )}
                    <DropdownMenuItem
                        onClick={() => handleLanguageChange(option.code)}
                        className={`flex items-center w-full px-4 py-3 relative group ${
                            language === option.code 
                                ? 'bg-gray-50 dark:bg-[#1c2128]' 
                                : ''
                        }`}
                    >
                        <span className="text-lg mr-3 flex-shrink-0 transition-transform duration-200 group-hover:scale-110">{option.flag}</span>
                        <span className={`text-sm font-medium transition-colors duration-150 ${language === option.code ? 'text-black dark:text-[#c9d1d9]' : 'text-gray-700 dark:text-[#b1bac4] group-hover:text-gray-900 dark:group-hover:text-[#c9d1d9]'}`}>
                            {option.label}
                        </span>
                    </DropdownMenuItem>
                </div>
            ))}
        </Dropdown>
    );
};

export default LanguageSwitcher; 